export const GET_SETTINGS_COMPANY = 'GET_SETTINGS_COMPANY';
export const GET_SETTINGS_COMPANY_SUCCESS = 'GET_SETTINGS_COMPANY_SUCCESS';
export const GET_SETTINGS_COMPANY_ERROR = 'GET_SETTINGS_COMPANY_ERROR';

export const PATCH_SETTINGS_COMPANY = 'PATCH_SETTINGS_COMPANY';
export const PATCH_SETTINGS_COMPANY_SUCCESS = 'PATCH_SETTINGS_COMPANY_SUCCESS';
export const PATCH_SETTINGS_COMPANY_ERROR = 'PATCH_SETTINGS_COMPANY_ERROR';

export const PATCH_LANG_SETTINGS_COMPANY = 'PATCH_LANG_SETTINGS_COMPANY';
export const PATCH_LANG_SETTINGS_COMPANY_SUCCESS = 'PATCH_LANG_SETTINGS_COMPANY_SUCCESS';

export const ADD_INFO_SETTING_SNACKBAR = 'ADD_INFO_SETTING_SNACKBAR';
export const DISMISS_SETTING_SNACKBAR = 'DISMISS_SETTING_SNACKBAR';
export const ADD_SETTING_SNACKBAR = 'ADD_SETTING_SNACKBAR';

export const GET_SETTINGS_WORK_TIME = 'GET_SETTINGS_WORK_TIME';
export const GET_SETTINGS_WORK_TIME_SUCCESS = 'GET_SETTINGS_WORK_TIME_SUCCESS';

export const PATCH_WORK_TIME = 'PATCH_WORK_TIME';
export const PATCH_WORK_TIME_SUCCESS = 'PATCH_WORK_TIME_SUCCESS';
export const PATCH_WORK_TIME_ERROR = 'PATCH_WORK_TIME_ERROR';

export const GET_WORKING_DAYS = 'GET_WORKING_DAYS';
export const GET_WORKING_DAYS_SUCCESS = 'GET_WORKING_DAYS_SUCCESS';
export const GET_WORKING_DAYS_ERROR = 'GET_WORKING_DAYS_ERROR';

export const GET_HOLIDAYS = 'GET_HOLIDAYS';
export const GET_HOLIDAYS_SUCCESS = 'GET_HOLIDAYS_SUCCESS';
export const GET_HOLIDAYS_ERROR = 'GET_HOLIDAYS_ERROR';

export const ADD_HOLIDAY = 'ADD_HOLIDAY';
export const ADD_HOLIDAY_SUCCESS = 'ADD_HOLIDAY_SUCCESS';
export const ADD_HOLIDAY_ERROR = 'ADD_HOLIDAY_ERROR';

export const DELETE_HOLIDAY = 'DELETE_HOLIDAY';
export const DELETE_HOLIDAY_SUCCESS = 'DELETE_HOLIDAY_SUCCESS';
export const DELETE_HOLIDAY_ERROR = 'DELETE_HOLIDAY_ERROR';

export const GET_SECURITY_COMPANY = 'GET_SECURITY_COMPANY';
export const GET_SECURITY_COMPANY_SUCCESS = 'GET_SECURITY_COMPANY_SUCCESS';
export const GET_SECURITY_COMPANY_ERROR = 'GET_SECURITY_COMPANY_ERROR';

export const PATCH_SECURITY_COMPANY = 'PATCH_SECURITY_COMPANY';
export const PATCH_SECURITY_COMPANY_SUCCESS = 'PATCH_SECURITY_COMPANY_SUCCESS';

export const GET_SETTINGS_SKILLS = 'GET_SETTINGS_SKILLS';
export const GET_SETTINGS_SKILLS_SUCCESS = 'GET_SETTINGS_SKILLS_SUCCESS';

export const CREATE_SKILL = 'CREATE_SKILL';
export const CREATE_SKILL_SUCCESS = 'CREATE_SKILL_SUCCESS';

export const PATCH_SKILL = 'PATCH_SKILL';
export const DELETE_SKILL = 'DELETE_SKILL';

export const CREATE_JOB = 'CREATE_JOB';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';

export const PATCH_JOB = 'PATCH_JOB';
export const DELETE_JOB = 'DELETE_JOB';

export const CREATE_PLACE = 'CREATE_PLACE';
export const CREATE_PLACE_SUCCESS = 'CREATE_PLACE_SUCCESS';

export const PATCH_PLACE = 'PATCH_PLACE';
export const DELETE_PLACE = 'DELETE_PLACE';

export const GET_PLACE = 'GET_PLACE';
export const GET_PLACE_SUCCESS = 'GET_PLACE_SUCCESS';

export const CREATE_CUSTOM_CATEGORY = 'CREATE_CUSTOM_CATEGORY';
export const CREATE_CUSTOM_CATEGORY_SUCCESS = 'CREATE_CUSTOM_CATEGORY_SUCCESS';

export const PATCH_CUSTOM_CATEGORY = 'PATCH_CUSTOM_CATEGORY';
export const DELETE_CUSTOM_CATEGORY = 'DELETE_CUSTOM_CATEGORY';

export const GET_CUSTOM_CATEGORY = 'GET_CUSTOM_CATEGORY';
export const GET_CUSTOM_CATEGORY_SUCCESS = 'GET_CUSTOM_CATEGORY_SUCCESS';

export const GET_COMPANY_SHIFT = 'GET_COMPANY_SHIFT';
export const GET_COMPANY_SHIFT_SUCCESS = 'GET_COMPANY_SHIFT_SUCCESS';

export const GET_COMPANY_JOB_TYPE = 'GET_COMPANY_JOB_TYPE';
export const GET_COMPANY_JOB_TYPE_SUCCESS = 'GET_COMPANY_JOB_TYPE_SUCCESS';

export const GET_SETTINGS_EMPLOYEES = 'GET_SETTINGS_EMPLOYEES';
export const GET_SETTINGS_EMPLOYEES_ALL = 'GET_SETTINGS_EMPLOYEES_ALL';
export const GET_SETTINGS_EMPLOYEES_SUCCESS = 'GET_SETTINGS_EMPLOYEES_SUCCESS';
export const GET_SETTINGS_EMPLOYEES_ERROR = 'GET_SETTINGS_EMPLOYEES_ERROR';
export const GET_SETTINGS_EMPLOYEES_QUERY = 'GET_SETTINGS_EMPLOYEES_QUERY';

export const GET_SETTINGS_EMPLOYEES_EDIT = 'GET_SETTINGS_EMPLOYEES_EDIT';
export const GET_SETTINGS_EMPLOYEES_EDIT_SUCCESS = 'GET_SETTINGS_EMPLOYEES_EDIT_SUCCESS';
export const GET_SETTINGS_EMPLOYEES_EDIT_ERROR = 'GET_SETTINGS_EMPLOYEES_EDIT_ERROR';

export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS';
export const UPDATE_EMPLOYEE_ERROR = 'UPDATE_EMPLOYEE_ERROR';

export const UPDATE_EMPLOYEE_LOGBOOK = 'UPDATE_EMPLOYEE_LOGBOOK';
export const UPDATE_EMPLOYEE_LOGBOOK_SUCCESS = 'UPDATE_EMPLOYEE_LOGBOOK_SUCCESS';
export const UPDATE_EMPLOYEE_LOGBOOK_ERROR = 'UPDATE_EMPLOYEE_LOGBOOK_ERROR';

export const DELETE_EMPLOYEE = 'DELETE_EMPLOYEE';
export const DELETE_EMPLOYEE_SUCCESS = 'DELETE_EMPLOYEE_SUCCESS';
export const DELETE_EMPLOYEE_ERROR = 'DELETE_EMPLOYEE_ERROR';

export const EMPLOYEE_ACTIONS = 'EMPLOYEE_ACTIONS';
export const EMPLOYEE_ACTIONS_SUCCESS = 'EMPLOYEE_ACTIONS_SUCCESS';
export const EMPLOYEE_ACTIONS_ERROR = 'EMPLOYEE_ACTIONS_ERROR';
export const EMPLOYEE_DROP_STATUS = 'EMPLOYEE_DROP_STATUS';

export const GET_ACTIVITY_LOG = 'GET_ACTIVITY_LOG';
export const GET_ACTIVITY_LOG_SUCCESS = 'GET_ACTIVITY_LOG_SUCCESS';

export const FILTER_ACTIVITY_LOG = 'FILTER_ACTIVITY_LOG';
export const FILTER_ACTIVITY_LOG_SUCCESS = 'FILTER_ACTIVITY_LOG_SUCCESS';

export const GET_DELETE_DATA = 'GET_DELETE_DATA';
export const GET_DELETE_DATA_SUCCESS = 'GET_DELETE_DATA_SUCCESS';

export const DELETE_DATA = 'DELETE_DATA';
export const DELETE_DATA_SUCCESS = 'DELETE_DATA_SUCCESS';

export const GET_LOGBOOK_JOURNAL = 'GET_LOGBOOK_JOURNAL';
export const GET_LOGBOOK_JOURNAL_SUCCESS = 'GET_LOGBOOK_JOURNAL_SUCCESS';

export const EDIT_LOGBOOK_JOURNAL = 'EDIT_LOGBOOK_JOURNAL';
export const EDIT_LOGBOOK_JOURNAL_SUCCESS = 'EDIT_LOGBOOK_JOURNAL_SUCCESS';

export const GET_TIME_SHEET = 'GET_TIME_SHEET';
export const GET_TIME_SHEET_SUCCESS = 'GET_TIME_SHEET_SUCCESS';

export const EDIT_TIME_SHEET = 'EDIT_TIME_SHEET';
export const EDIT_TIME_SHEET_SUCCESS = 'EDIT_TIME_SHEET_SUCCESS';

export const GET_INTEGRATIONS = 'GET_INTEGRATIONS';
export const GET_INTEGRATIONS_SUCCESS = 'GET_INTEGRATIONS_SUCCESS';

export const EDIT_INTEGRATIONS = 'EDIT_INTEGRATIONS';
export const EDIT_INTEGRATIONS_SUCCESS = 'EDIT_INTEGRATIONS_SUCCESS';

export const IMPORT_IIKO = 'IMPORT_IIKO';
export const IMPORT_IIKO_RESULT = 'IMPORT_IIKO_RESULT';

export const GET_LOGBOOK_OVERTIME = 'GET_LOGBOOK_OVERTIME';
export const GET_LOGBOOK_OVERTIME_SUCCESS = 'GET_LOGBOOK_OVERTIME_SUCCESS';

export const EDIT_LOGBOOK_OVERTIME = 'EDIT_LOGBOOK_OVERTIME';
export const EDIT_LOGBOOK_OVERTIME_SUCCESS = 'EDIT_LOGBOOK_OVERTIME_SUCCESS';

export const GET_LOGBOOK_ADDITIONAL_RATES = 'GET_LOGBOOK_ADDITIONAL_RATES';
export const GET_LOGBOOK_ADDITIONAL_RATES_SUCCESS = 'GET_LOGBOOK_ADDITIONAL_RATES_SUCCESS';

export const EDIT_LOGBOOK_ADDITIONAL_RATES = 'EDIT_LOGBOOK_ADDITIONAL_RATES';
export const EDIT_LOGBOOK_ADDITIONAL_RATES_SUCCESS = 'EDIT_LOGBOOK_ADDITIONAL_RATES_SUCCESS';

export const GET_LOGBOOK_CLOCK = 'GET_LOGBOOK_CLOCK';
export const GET_LOGBOOK_CLOCK_SUCCESS = 'GET_LOGBOOK_CLOCK_SUCCESS';

export const EDIT_LOGBOOK_CLOCK = 'EDIT_LOGBOOK_CLOCK';
export const EDIT_LOGBOOK_CLOCK_SUCCESS = 'EDIT_LOGBOOK_CLOCK_SUCCESS';

export const GET_AUTO_DELETE = 'GET_AUTO_DELETE';
export const GET_AUTO_DELETE_SUCCESS = 'GET_AUTO_DELETE_SUCCESS';

export const EDIT_AUTO_DELETE = 'EDIT_AUTO_DELETE';
export const EDIT_AUTO_DELETE_SUCCESS = 'EDIT_AUTO_DELETE_SUCCESS';

export const GET_ACCOUNTS_GROUPS = 'GET_ACCOUNTS_GROUPS';
export const GET_ACCOUNTS_GROUPS_SUCCESS = 'GET_ACCOUNTS_GROUPS_SUCCESS';

export const CREATE_ACCOUNTS_GROUP = 'CREATE_ACCOUNTS_GROUP';
export const CREATE_ACCOUNTS_GROUP_SUCCESS = 'CREATE_ACCOUNTS_GROUP_SUCCESS';
export const CREATE_ACCOUNTS_GROUP_ERROR = 'CREATE_ACCOUNTS_GROUP_ERROR';

export const PATCH_ACCOUNTS_GROUP = 'PATCH_ACCOUNTS_GROUP';
export const PATCH_ACCOUNTS_GROUP_SUCCESS = 'PATCH_ACCOUNTS_GROUP_SUCCESS';
export const PATCH_ACCOUNTS_GROUP_ERROR = 'PATCH_ACCOUNTS_GROUP_ERROR';

export const DELETE_ACCOUNTS_GROUP = 'DELETE_ACCOUNTS_GROUP';
export const DELETE_ACCOUNTS_GROUP_SUCCESS = 'DELETE_ACCOUNTS_GROUP_SUCCESS';
export const DELETE_ACCOUNTS_GROUP_ERROR = 'DELETE_ACCOUNTS_GROUP_ERROR';

export const CREATE_ACCOUNTS_SUBGROUP = 'CREATE_ACCOUNTS_SUBGROUP';
export const CREATE_ACCOUNTS_SUBGROUP_SUCCESS = 'CREATE_ACCOUNTS_SUBGROUP_SUCCESS';
export const CREATE_ACCOUNTS_SUBGROUP_ERROR = 'CREATE_ACCOUNTS_SUBGROUP_ERROR';

export const PATCH_ACCOUNTS_SUBGROUP = 'PATCH_ACCOUNTS_SUBGROUP';
export const PATCH_ACCOUNTS_SUBGROUP_SUCCESS = 'PATCH_ACCOUNTS_SUBGROUP_SUCCESS';
export const PATCH_ACCOUNTS_SUBGROUP_ERROR = 'PATCH_ACCOUNTS_SUBGROUP_ERROR';

export const DELETE_ACCOUNTS_SUBGROUP = 'DELETE_ACCOUNTS_SUBGROUP';
export const DELETE_ACCOUNTS_SUBGROUP_SUCCESS = 'DELETE_ACCOUNTS_SUBGROUP_SUCCESS';
export const DELETE_ACCOUNTS_SUBGROUP_ERROR = 'DELETE_ACCOUNTS_SUBGROUP_ERROR';

export const GET_ROLES = 'GET_ROLES';
export const GET_ROLES_SUCCESS = 'GET_ROLES_SUCCESS';
export const GET_ROLES_ERROR = 'GET_ROLES_ERROR';

export const CREATE_ROLE = 'CREATE_ROLE';
export const CREATE_ROLE_SUCCESS = 'CREATE_ROLE_SUCCESS';
export const CREATE_ROLE_ERROR = 'CREATE_ROLE_ERROR';

export const DELETE_ROLE = 'DELETE_ROLE';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const DELETE_ROLE_ERROR = 'DELETE_ROLE_ERROR';

export const UPDATE_ROLE = 'UPDATE_ROLE';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const UPDATE_ROLE_ERROR = 'UPDATE_ROLE_ERROR';

export const GET_ROLE_DETAILS = 'GET_ROLE_DETAILS';
export const GET_ROLE_DETAILS_SUCCESS = 'GET_ROLE_DETAILS_SUCCESS';
export const GET_ROLE_DETAILS_ERROR = 'GET_ROLE_DETAILS_ERROR';


export const GET_TIME_OFFS = 'GET_TIME_OFFS';
export const GET_TIME_OFFS_SUCCESS = 'GET_TIME_OFFS_SUCCESS';
export const GET_TIME_OFFS_ERROR = 'GET_TIME_OFFS_ERROR';

export const CREATE_TIME_OFF = 'CREATE_TIME_OFF';
export const CREATE_TIME_OFF_SUCCESS = 'CREATE_TIME_OFF_SUCCESS';
export const CREATE_TIME_OFF_ERROR = 'CREATE_TIME_OFF_ERROR';

export const DELETE_TIME_OFF = 'DELETE_TIME_OFF';
export const DELETE_TIME_OFF_SUCCESS = 'DELETE_TIME_OFF_SUCCESS';
export const DELETE_TIME_OFF_ERROR = 'DELETE_TIME_OFF_ERROR';

export const UPDATE_TIME_OFF = 'UPDATE_TIME_OFF';
export const UPDATE_TIME_OFF_SUCCESS = 'UPDATE_TIME_OFF_SUCCESS';
export const UPDATE_TIME_OFF_ERROR = 'UPDATE_TIME_OFF_ERROR';

export const GET_POLICIES = 'GET_POLICIES';
export const GET_POLICIES_SUCCESS = 'GET_POLICIES_SUCCESS';
export const GET_POLICIES_ERROR = 'GET_POLICIES_ERROR';

export const GET_POLICY_EMPLOYEE = 'GET_POLICY_EMPLOYEE';
export const GET_POLICY_EMPLOYEE_SUCCESS = 'GET_POLICY_EMPLOYEE_SUCCESS';
export const GET_POLICY_EMPLOYEE_ERROR = 'GET_POLICY_EMPLOYEE_ERROR';

export const CREATE_POLICY = 'CREATE_POLICY';
export const CREATE_POLICY_SUCCESS = 'CREATE_POLICY_SUCCESS';
export const CREATE_POLICY_ERROR = 'CREATE_POLICY_ERROR';

export const DELETE_POLICY = 'DELETE_POLICY';
export const DELETE_POLICY_SUCCESS = 'DELETE_POLICY_SUCCESS';
export const DELETE_POLICY_ERROR = 'DELETE_POLICY_ERROR';

export const UPDATE_POLICY = 'UPDATE_POLICY';
export const UPDATE_POLICY_SUCCESS = 'UPDATE_POLICY_SUCCESS';
export const UPDATE_POLICY_ERROR = 'UPDATE_POLICY_ERROR';

export const UPDATE_POLICY_SETTINGS = 'UPDATE_POLICY_SETTINGS';
export const UPDATE_POLICY_SETTINGS_SUCCESS = 'UPDATE_POLICY_SETTINGS_SUCCESS';
export const UPDATE_POLICY_SETTINGS_ERROR = 'UPDATE_POLICY_SETTINGS_ERROR';

export const UPDATE_POLICY_EMPLOYEES = 'UPDATE_POLICY_EMPLOYEES';
export const UPDATE_POLICY_EMPLOYEES_SUCCESS = 'UPDATE_POLICY_EMPLOYEES_SUCCESS';
export const UPDATE_POLICY_EMPLOYEES_ERROR = 'UPDATE_POLICY_EMPLOYEES_ERROR';

export const UNASIGN_POLICY_EMPLOYEES = 'UNASIGN_POLICY_EMPLOYEES';
export const UNASIGN_POLICY_EMPLOYEES_SUCCESS = 'UNASIGN_POLICY_EMPLOYEES_SUCCESS';
export const UNASIGN_POLICY_EMPLOYEES_ERROR = 'UNASIGN_POLICY_EMPLOYEES_ERROR';

export const DUPLICATE_POLICY = 'DUPLICATE_POLICY';
export const DUPLICATE_POLICY_SUCCESS = 'DUPLICATE_POLICY_SUCCESS';
export const DUPLICATE_POLICY_ERROR = 'DUPLICATE_TPOLICY_ERROR';

export const CREATE_REQUEST_BEHALF = 'CREATE_REQUEST_BEHALF';
export const CREATE_REQUEST_BEHALF_SUCCESS = 'CREATE_REQUEST_BEHALF_SUCCESS';
export const CREATE_REQUEST_BEHALF_ERROR = 'CREATE_REQUEST_BEHALF_ERROR';

export const UPDATE_REQUEST_BEHALF = 'UPDATE_REQUEST_BEHALF';
export const UPDATE_REQUEST_BEHALF_SUCCESS = 'UPDATE_REQUEST_BEHALF_SUCCESS';
export const UPDATE_REQUEST_BEHALF_ERROR = 'UPDATE_REQUEST_BEHALF_ERROR';

export const CHANGE_REQUEST_BEHALF_STATUS = 'CHANGE_REQUEST_BEHALF_STATUS';
export const CHANGE_REQUEST_BEHALF_STATUS_SUCCESS = 'CHANGE_REQUEST_BEHALF_STATUS_SUCCESS';
export const CHANGE_REQUEST_BEHALF_STATUS_ERROR = 'CHANGE_REQUEST_BEHALF_STATUS_ERROR';

export const GET_REQUEST_BEHALF = 'GET_REQUEST_BEHALF';
export const GET_REQUEST_BEHALF_SUCCESS = 'GET_REQUEST_BEHALF_SUCCESS';
export const GET_REQUEST_BEHALF_ERROR = 'GET_REQUEST_BEHALF_ERROR';

export const UPDATE_POLICY_ACTIVITY = 'UPDATE_POLICY_ACTIVITY';
export const UPDATE_POLICY_ACTIVITY_SUCCESS = 'UPDATE_POLICY_ACTIVITY_SUCCESS';
export const UPDATE_POLICY_ACTIVITY_ERROR = 'UPDATE_POLICY_ACTIVITY_ERROR';

export const REMOVE_POLICY_ACTIVITY = 'REMOVE_POLICY_ACTIVITY';
export const REMOVE_POLICY_ACTIVITY_SUCCESS = 'REMOVE_POLICY_ACTIVITY_SUCCESS';
export const REMOVE_POLICY_ACTIVITY_ERROR = 'REMOVE_POLICY_ACTIVITY_ERROR';

export const CREATE_ADJUST_BALANCE = 'CREATE_ADJUST_BALANCE';
export const CREATE_ADJUST_BALANCE_SUCCESS = 'CREATE_ADJUST_BALANCE_SUCCESS';
export const CREATE_ADJUST_BALANCE_ERROR = 'CREATE_ADJUST_BALANCE_ERROR';

export const CREATE_ADJUST_TIME_USED = 'CREATE_ADJUST_TIME_USED';
export const CREATE_ADJUST_TIME_USED_SUCCESS = 'CREATE_ADJUST_TIME_USED_SUCCESS';
export const CREATE_ADJUST_TIME_USED_ERROR = 'CREATE_ADJUST_TIME_USED_ERROR';

export const GET_CURRENCY = 'GET_CURRENCY';
export const GET_CURRENCY_SUCCESS = 'GET_CURRENCY_SUCCESS';

export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
export const CREATE_EMPLOYEE_ERROR = 'CREATE_EMPLOYEE_ERROR';

export const LOAD_PERMISSIONS = 'LOAD_PERMISSIONS';
export const LOAD_PERMISSIONS_SUCCESS = 'LOAD_PERMISSIONS_SUCCESS';
export const LOAD_PERMISSIONS_ERROR = 'LOAD_PERMISSIONS_ERROR';

export const SEND_IMPORTED_EMPLOYEES = 'SEND_IMPORTED_EMPLOYEES';
export const SEND_IMPORTED_EMPLOYEES_SUCCESS = 'SEND_IMPORTED_EMPLOYEES_SUCCESS';
export const SEND_IMPORTED_EMPLOYEES_ERROR = 'SEND_IMPORTED_EMPLOYEES_ERROR';

export const SEND_IMPORTED_PLACES = 'SEND_IMPORTED_PLACES';
export const SEND_IMPORTED_PLACES_SUCCESS = 'SEND_IMPORTED_PLACES_SUCCESS';
export const SEND_IMPORTED_PLACES_ERROR = 'SEND_IMPORTED_PLACES_ERROR';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR';

export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';
export const POST_EVENT = 'POST_EVENT';
export const POST_EVENT_SUCCESS = 'POST_EVENT_SUCCESS';
export const PATCH_EVENT = 'PATCH_EVENT';
export const PATCH_EVENT_SUCCESS = 'PATCH_EVENT_SUCCESS';
export const DELETE_EVENT = 'DELETE_EVENT';
export const DELETE_EVENT_SUCCESS = 'DELETE_EVENT_SUCCESS';

// schedule
export const GET_SETTINGS_SCHEDULE = 'GET_SETTINGS_SCHEDULE';
export const GET_SETTINGS_SCHEDULE_SUCCESS = 'GET_SETTINGS_SCHEDULE_SUCCESS';
export const GET_SETTINGS_SCHEDULE_ERROR = 'GET_SETTINGS_SCHEDULE_ERROR';
export const POST_SETTINGS_SCHEDULE = 'POST_SETTINGS_SCHEDULE';

// sheet
export const GET_SETTINGS_SHEET = 'GET_SETTINGS_SHEET';
export const GET_SETTINGS_SHEET_SUCCESS = 'GET_SETTINGS_SHEET_SUCCESS';
export const GET_SETTINGS_SHEET_ERROR = 'GET_SETTINGS_SHEET_ERROR';

// integration
export const GET_SETTINGS_INTEGRATION = 'GET_SETTINGS_INTEGRATION';
export const GET_SETTINGS_INTEGRATION_SUCCESS = 'GET_SETTINGS_INTEGRATION_SUCCESS';
export const GET_SETTINGS_INTEGRATION_ERROR = 'GET_SETTINGS_INTEGRATION_ERROR';
